import React from 'react';

import Grid from '@mui/material/Grid';
import { type Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { Box } from '../../../ui/atoms/Box';
import { GridContainer } from '../../../ui/atoms/GridContainer';
import { SkeletonLoader } from '../../../ui/atoms/SkeletonLoader';

const useStyles = makeStyles(({ breakpoints, spacing }: Theme) => ({
  fullLine: {
    marginTop: '8px',
  },
  gridItem: {
    padding: spacing(1.5),
    [breakpoints.down('md')]: { padding: spacing(1) },
  },
}));

type AppStoreAppsListLoadingSkeletonTypes = {
  width?: 12 | 6;
};

export const AppStoreAppsListLoadingSkeleton = ({
  width,
}: AppStoreAppsListLoadingSkeletonTypes): JSX.Element => {
  const classes = useStyles();

  const renderLoadingSkeleton = () => {
    const cardArray: JSX.Element[] = [];
    for (let i = 0; i < 6; i++) {
      cardArray.push(
        <Grid
          key={`skeleton-card-${i}`}
          item
          xs={12}
          sm={12}
          md={width || 6}
          className={classes.gridItem}
        >
          <Box>
            <SkeletonLoader
              fdKey={`skeleton-card-${i}`}
              rows={[
                { height: '34px', width: '100%' },
                { height: '34px', width: '100%', className: classes.fullLine },
              ]}
            />
          </Box>
        </Grid>
      );
    }
    return cardArray;
  };
  return <GridContainer width="md">{renderLoadingSkeleton()}</GridContainer>;
};
